// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"Footer_footerLink__S9lkn","link":"Footer_link__eQs2R","copy":"Footer_copy__ZCZtA","image":"Footer_image__iUM9e"};